import { useState } from 'react';

export const TemplateVariablesTable = ({
  data,
  title,
  copyToClipboard,
  copyAllToClipboard,
}: {
  data: string[];
  title: string;
  copyToClipboard: (text: string) => void;
  copyAllToClipboard: (text: string[]) => void;
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  if (!data || data.length === 0) return null;

  const filteredData = data.filter((variable) =>
    variable.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="mt-4">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-primary-300 font-medium text-sm">{title}</h3>
        {data.length > 0 && (
          <button
            onClick={() => copyAllToClipboard(data)}
            className="text-xs bg-primary-100 text-primary-600 hover:bg-primary-200 px-2 py-1 rounded-md transition duration-150 ease-in-out flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3 w-3 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
            Copy All
          </button>
        )}
      </div>
      <div className="mb-2">
        <input
          type="text"
          placeholder="Search variables..."
          className="w-full px-3 py-2 border border-neutral-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="border border-neutral-200 rounded-md overflow-hidden">
        <div className="overflow-y-auto max-h-[300px] scrollbar-thin scrollbar-thumb-neutral-300 scrollbar-track-neutral-100">
          <table className="min-w-full border-separate border-spacing-0">
            <thead className="sticky top-0 z-10">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-extrabold text-white tracking-wide bg-primary_bg_color border-r border-white/35">
                  Variable
                </th>
                <th className="px-4 py-3 text-left text-sm font-extrabold text-white tracking-wide bg-primary_bg_color w-20">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-neutral-200">
              {filteredData.length > 0 ? (
                filteredData.map((variable, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}>
                    <td className="px-4 py-2 text-sm text-neutral-900">{variable}</td>
                    <td className="px-4 py-2 text-sm">
                      <button
                        onClick={() => copyToClipboard(variable)}
                        className="text-primary-300 hover:text-primary-400 focus:outline-none transition duration-150 ease-in-out p-1 rounded hover:bg-neutral-100"
                        title="Copy to clipboard">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} className="px-4 py-4 text-sm text-neutral-500 text-center italic">
                    No matching variables found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
